export default {"src":"/_next/static/media/logo-circle.f99802f6.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};